import { Skeleton } from '@mui/material';
import React from 'react';
import { Card, CardBody } from 'reactstrap';

export default function GrowthSkeleton() {
  return (
    <div role="status" aria-label="Loading page views" aria-busy="true">
      <div aria-hidden="true">
        <div
          style={{
            display: 'flex',
            gap: 16,
            flexWrap: 'wrap',
            margin: '16px 0',
          }}
        >
          {['views', 'sessions', 'bots', 'other'].map((key) => (
            <Card key={key} style={{ flex: '1 1 180px' }}>
              <CardBody>
                <Skeleton width="45%" height={24} />
                <Skeleton width="60%" height={40} />
              </CardBody>
            </Card>
          ))}
        </div>
        <Card>
          <CardBody>
            <Skeleton width={120} height={24} />
            <Skeleton variant="rounded" width={220} height={38} />
            <div
              style={{
                display: 'flex',
                gap: 18,
                flexWrap: 'wrap',
                margin: '16px 0',
              }}
            >
              {['one', 'two', 'three'].map((key) => (
                <Skeleton key={key} width={150} height={24} />
              ))}
            </div>
            <Skeleton
              variant="rounded"
              width="100%"
              sx={{ aspectRatio: '1100 / 315', minHeight: 240 }}
            />
            <Skeleton width="70%" height={28} style={{ marginTop: 16 }} />
          </CardBody>
        </Card>
        <Card style={{ marginTop: 16 }}>
          <CardBody>
            <h4>Top routes</h4>
            <Skeleton width="60%" height={24} />
            <Skeleton
              variant="rounded"
              height={36}
              style={{ margin: '16px 0 8px' }}
            />
            {['one', 'two', 'three', 'four', 'five'].map((key) => (
              <Skeleton key={key} height={40} width="100%" />
            ))}
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
